import type { Filters } from '@/features/filters';
import type { Rules } from '@/entities/session';
import type {
  DimensionColumnDataType,
  DimensionDataFormatType,
} from '@/shared/types';

export enum UserStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

export enum CLSType {
  BLACKLIST = 'blacklist',
  WHITELIST = 'whitelist',
}

export interface CLSFilters {
  type: CLSType;
  columns: string[];
}

export interface UserSettingsMeta {
  clsColumns: string[];
  rlsColumns: string[];
  config: Record<
    string,
    {
      name: string;
      description: string;
      group: string;
      dataType: DimensionDataFormatType;
      type: DimensionColumnDataType;
      order: number;
    }
  >;
}

export interface User {
  id: string;
  email: string;
  roleId: string;
  roleName: string;
  isActive: boolean;
  lastActiveAt?: string;
}

export type RoleRules = Rules &
  Partial<{
    rlsFilters: { dimensionFilters: Filters };
    clsFilters: CLSFilters;
  }>;

export interface Role {
  id: string;
  name: string | null;
  description: string | null;
  organizationId: string | null;
  rules: RoleRules;
}

export interface CreateRoleParams {
  name: string;
  description?: string;
  rules: RoleRules;
}
